import { createSelector } from 'reselect';
import {
    get, has, filter, values, pick,
} from 'lodash';

/**
 * Base Selectors
 */
const getEntityId = (state, id) => id;
const getEntities = (state) => state.app.database.reservationServices;
const getMetaEntities = (state) => state.app.metaDatabase.reservationServices;
const getVendorServices = (state) => state.app.database.vendorServices;
const getVendors = (state) => state.app.database.vendors;
const getReservationServiceNumbers = (state) => state.app.database.reservationServiceNumbers;
const getCurrencies = (state) => state.app.database.currencies;

/**
 * Selector Builders
 */
export const buildMetaReservationServiceSelector = () => createSelector([getEntityId, getMetaEntities], (entityId, metaEntities) =>
{
    if (has(metaEntities, entityId))
    {
        return metaEntities[entityId];
    }

    return {};
});

export const buildReservationServiceSelector = () => createSelector([getEntityId, getEntities], (entityId, entities) =>
{
    if (has(entities, entityId))
    {
        return entities[entityId];
    }

    return {};
});

export const buildReservationServicesSelector = () => createSelector([getEntityId, getEntities], (entityIds, entities) => values(pick(entities, entityIds)));

export const buildReservationServicesByReservationIdSelector = () => createSelector([getEntityId, getEntities, getVendorServices, getVendors, getReservationServiceNumbers, getCurrencies], (reservationId, reservationServices, vendorServices, vendors, reservationServiceNumbers, currencies) => filter(reservationServices, { reservation_id: reservationId }).map((reservationService) =>
{
    const vendorService = vendorServices[reservationService.vendor_service_id];
    let service = null;

    if (vendorService)
    {
        service = {
            ...vendorService,
            vendor: {
                ...vendors[vendorService.vendor_id],
            },
        };
    }

    return {
        ...reservationService,
        currency: get(currencies, reservationService.currency_id, {}),
        numbers: get(reservationServiceNumbers, `ReservationService_${reservationService.id}_Numbers`, {}),
        service,
    };
}));
